import React from "react";
import classnames from "classnames";

const WebSimulatorBody = ({children, className, ...props}) => {

    return (
        <>
            <div className={classnames('web-simulator-body', className)} {...props}>
                {children}
            </div>
        </>
    )
}

export default WebSimulatorBody;
